export const codeProcessRequestTypes = [
  { label: "Cấp mới", value: "provide" },
  { label: "Thay đổi", value: "change" },
  { label: "Xoá", value: "delete" },
];
export const codeProcessTypes = [
  { label: "Nội bộ", value: "Internal" },
  { label: "Bên ngoài", value: "External" },
];

export const approverType = {
  approver: 1,
  itlead: 2,
  ithead: 3,
  assignee: 4,
};
